import axiosInstance from 'src/utils/axios';
import * as Types from './types.api';

//
//

const BASE_URL = 'merchants/v1';

//

export const updateProgrammeAPI = async (payload: Types.UpdateProgrammePayload) => {
  const { merchantCode, programmeCode, ...rest } = payload;

  return axiosInstance.patch(
    `${BASE_URL}/${merchantCode}/programmes/${programmeCode}`,
    JSON.stringify(rest)
  );
};

//

export const getProgrammesListAPI = async (
  query: Types.GetProgrammesQuery
): Promise<Types.GetProgrammesResponse> => {
  const { merchantCode } = query;

  const response = await axiosInstance.get<Types.GetProgrammesResponse>(
    `${BASE_URL}/${merchantCode}/programmes`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

//

export const createProgrammeAPI = async (
  paylpad: Types.CreateProgrammePayload
): Promise<Types.GetProgrammesResponse> => {
  const { merchantCode, ...params } = paylpad;

  const response = await axiosInstance.post<Types.GetProgrammesResponse>(
    `${BASE_URL}/${merchantCode}/programmes`,
    {
      ...params,
    }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
